import { FeatureFlag } from '../FeatureFlag';

export const enableLabFirmBorrowStatus = new FeatureFlag({
    key: 'enable-lab-firm-borrow-status',
    createdOn: '2026-09-10',
    defaultValue: false,
});
